import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useCallback, useMemo } from 'react';
import { components } from 'react-select';
import classNames from 'classnames/bind';
import { arrayOf, bool, node, oneOfType } from 'prop-types';
import styles from '../Select.css';
import { innerPropsPropTypes, selectPropsPropTypes } from '../shapes';
var cx = classNames.bind(styles);
export var Control = function Control(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var menuIsOpen = props.menuIsOpen,
      _props$selectProps = props.selectProps,
      isDisabled = _props$selectProps.isDisabled,
      options = _props$selectProps.options,
      inputValue = _props$selectProps.inputValue,
      isNoOptionsReturnNull = _props$selectProps.isNoOptionsReturnNull,
      controlProps = _props$selectProps.controlProps,
      isAutofill = _props$selectProps.isAutofill,
      classes = _props$selectProps.classes,
      innerProps = props.innerProps;
  var findOption = useCallback(function (_ref2) {
    var label = _ref2.label,
        name = _ref2.name,
        code = _ref2.code;
    var textValue = ("".concat(name).concat(code) || label).toLowerCase().replace(/ё/g, 'е');
    var stateValue = inputValue.toLowerCase().replace(/ё/g, 'е');
    return textValue.indexOf(stateValue) >= 0;
  }, [inputValue]);
  var isControlOpened = useMemo(function () {
    switch (true) {
      case inputValue && !options.find(function (option) {
        return option === findOption;
      }) && isNoOptionsReturnNull:
      case options.length === 0 && isNoOptionsReturnNull:
        return false;

      default:
        return menuIsOpen;
    }
  }, [inputValue, findOption, options, isNoOptionsReturnNull, menuIsOpen]);
  return /*#__PURE__*/React.createElement(components.Control, _extends({}, props, {
    innerProps: _objectSpread(_objectSpread({}, innerProps), controlProps),
    className: cx('Control', {
      Control_opened: isControlOpened,
      Control_disabled: isDisabled,
      Control_autofill: isAutofill
    }, classes.control)
  }), children);
};
Control.propTypes = process.env.NODE_ENV !== "production" ? {
  children: oneOfType([arrayOf(node), node]).isRequired,
  innerProps: innerPropsPropTypes,
  menuIsOpen: bool,
  selectProps: selectPropsPropTypes
} : {};